<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline">
        <span>
          <span style="color:gray;">brain</span><span style="color:green;">XT</span>
          <!-- <router-link to="/contact">Go to Contact</router-link> 
          | 
          <router-link to="/caplogs">Load Logs</router-link></span> -->
        <!-- <span class="font-weight-light">{{userEmail}}</span> -->
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!isLoggedIn"
        v-on:click="login()"
      >
        <span class="mr-2">Signin</span>
      </v-btn>
      <v-btn v-if="isLoggedIn"
        v-on:click="logout()"
      >
        <span class="mr-2">Signout</span>
      </v-btn>
      <MyAccountControl v-if="isLoggedIn"/>
      <!--<v-badge :color="myEdit ? 'green' : 'red'">
        <template v-slot:badge>
          <span></span>
        </template>
      </v-badge>
      -->
    </v-toolbar>
    <v-content class="content" pt-1>
    <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld'
import MyAccountControl from './components/MyAccountControl'
import * as firebaseui from 'firebaseui'
import * as firebase from 'firebase'
import {mapState} from 'vuex'
export default {
  name: 'App',
  components: {
    MyAccountControl//HelloWorld, MyProfile
  },
  computed : {
    userEmail : function(){
      //console.log(this.$store)
      if(this.$store.state.userEmail){
        return this.$store.state.userEmail 
      }
      else{
        return this.$store.state.count;
      }      
    },
    isLoggedIn : function(){
      return this.$store.state.isLoggedIn
    },
    ...mapState(['myEdit'])
  },
  watch :{
    myEdit : function(){
      
    }
  },
  methods: {
    login : function(){
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithPopup(provider).then(function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        // ...
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });
    },
    logout : function(){
      var myThis = this
      firebase.auth().signOut().then(function() {
        myThis.$store.dispatch('userSignedOut')
      }).catch(function(error) {
        console.log("Something went wrong when signingout", error)
      });
    }
  }
}
</script>

<style scoped>
  .content{
    display: flex
  }
</style>